export default __webpack_public_path__ + "static/media/franchinsing-mina.dc381359.png";